import { Grid, TextField } from '@mui/material';

export const Text = ({
  grid,
  value,
  onChange,
  question,
  required,
  ...rest
}) => (
  <Grid
    item
    className="text-input"
    xs={grid || 12}
    md={grid || 6}
    lg={grid || 3}
  >
    <TextField
      size="small"
      id="outlined"
      value={value}
      required={required}
      label={question}
      onChange={({ target: { value } }) => onChange(value)}
      {...rest}
    />
  </Grid>
);
